// Bileli · i18n — Kyrgyz for the STUDENT (learn) module: catalog, dashboard, course page, player, quiz.
// Keys are the exact Russian source strings (incl. `{var}` placeholders). Terminology follows the design
// dictionary (design/bileli_app/app/i18n.js): урок→сабак, бесплатно→акысыз, ОРТ→ЖРТ, отзывы→пикирлер.
// Strings whose Kyrgyz is identical to the Russian (Каталог, Кыргызча, Программа, «{n} сом», Салам) are
// deliberately ABSENT — t() falls back to the key, and the sanity test rejects value==key entries.
export const KY_LEARN: Record<string, string> = {
  // Dashboard (student home)
  'Продолжим учиться': 'Окууну улантабыз',
  Продолжить: 'Улантуу',
  'Урок {n} из {m}': 'Сабак {n} / {m}',
  'Мои курсы': 'Менин курстарым',
  'Все курсы →': 'Бардык курстар →',
  'Bileli · Учёба': 'Bileli · Окуу',
  'Начните учиться': 'Окууну баштаңыз',
  'Вы ещё не записаны на курсы — откройте каталог и выберите первый.':
    'Сиз азырынча курстарга жазыла элексиз — каталогду ачып, биринчисин тандаңыз.',
  'Открыть каталог': 'Каталогду ачуу',
  Рекомендуем: 'Сунуш кылабыз',

  // Catalog (LearnList) + hero banner (model/banner.ts constants, translated at the usage site)
  '🇰🇬 ОРТ 2026': '🇰🇬 ЖРТ 2026',
  'Готовься к ОРТ с лучшими учителями Кыргызстана': 'ЖРТга Кыргызстандын мыкты мугалимдери менен даярдан',
  'Курсы по школьной программе и подготовке к ОРТ — на кыргызском и русском.':
    'Мектеп программасы жана ЖРТга даярдык боюнча курстар — кыргыз жана орус тилдеринде.',
  Все: 'Баары',
  'Поиск курсов…': 'Курс издөө…',
  // Filter pill-dropdowns (FilterSelect): «{label}: {value}» — Предмет is identical in KY (omitted),
  // Цена already lives in ky.teach.
  Язык: 'Тил',
  все: 'баары',
  Русский: 'Орусча',
  Бесплатно: 'Акысыз',
  Платно: 'Акылуу',
  '{n} курсов': '{n} курс',
  'Курсы не найдены — попробуйте изменить фильтры или поиск.':
    'Курстар табылган жок — фильтрлерди же издөөнү өзгөртүп көрүңүз.',

  // Course landing (CourseDetailView)
  '← Назад к курсам': '← Курстарга кайтуу',
  'Не удалось загрузить курс.': 'Курсту жүктөө мүмкүн болгон жок.',
  'Входим в Bileli…': 'Bileli\'ге кирүүдө…',
  'Войти, чтобы записаться': 'Жазылуу үчүн кириңиз',
  'Перейти к обучению': 'Окууга өтүү',
  'Набор закрыт': 'Кабыл алуу жабык',
  'Записаться · {price}': 'Жазылуу · {price}',
  'Записаться бесплатно': 'Акысыз жазылуу',
  'Записываем…': 'Жазып жатабыз…',
  Преподаватель: 'Мугалим',
  'Чему вы научитесь': 'Эмнени үйрөнөсүз',
  'Программа курса': 'Курс программасы',
  '{n} уроков': '{n} сабак',
  '{n} мин': '{n} мүн',
  'Доступ навсегда': 'Өмүр бою жеткиликтүү',
  'Пространство курса': 'Курстун мейкиндиги',
  'Гарантия возврата средств в течение 7 дней': 'Акчаны 7 күн ичинде кайтаруу кепилдиги',
  'Доступ с телефона': 'Телефондон жеткиликтүү',

  // Paid checkout (payments · CheckoutSheet — Finik). «{n} сом» / «Перейти к обучению» already above.
  'Оплата курса': 'Курс үчүн төлөм',
  'Готовим оплату…': 'Төлөмдү даярдап жатабыз…',
  'Оплатить через Finik': 'Finik аркылуу төлөө',
  'Открыть оплату снова': 'Төлөмдү кайра ачуу',
  'Действует ещё {time}': 'Дагы {time} жарактуу',
  'Ожидаем подтверждение оплаты…': 'Төлөмдүн ырасталышын күтүүдөбүз…',
  'Оплата откроется в новой вкладке. Вернитесь сюда после оплаты.':
    'Төлөм жаңы өтмөктө ачылат. Төлөгөндөн кийин бул жерге кайтыңыз.',
  'Оплата прошла!': 'Төлөм ийгиликтүү өттү!',
  'Доступ к курсу открыт. Приятной учёбы!': 'Курска жол ачылды. Жакшы окууну каалайбыз!',
  'Время оплаты истекло': 'Төлөм убактысы бүттү',
  'Заказ не был оплачён вовремя. Создайте новый.': 'Буйрутма өз убагында төлөнгөн жок. Жаңысын түзүңүз.',
  'Создать заказ заново': 'Буйрутманы кайра түзүү',
  'Оплата временно недоступна': 'Төлөм убактылуу жеткиликсиз',
  'Попробуйте ещё раз через минуту.': 'Бир мүнөттөн кийин кайра аракет кылыңыз.',
  'Не удалось оформить оплату': 'Төлөмдү тариздөө мүмкүн болгон жок',
  'Попробуйте ещё раз позже.': 'Кийинчерээк кайра аракет кылыңыз.',
  Повторить: 'Кайталоо',
  // 2026-08 contract refresh: claim-aware states, bounded watch, store-hold branches (mirrors the
  // iOS/Android pay-sheet chips: «Текшерүү», «Төлөмүңүз бизде…», «Уруксат күтүлүүдө…»).
  Проверить: 'Текшерүү',
  'Проверяем статус заказа…': 'Буйрутманын абалын текшерүүдөбүз…',
  'Долго нет ответа. Проверьте статус вручную.': 'Жооп көпкө жок. Абалын өзүңүз текшериңиз.',
  '🔒 Безопасная оплата через Finik': '🔒 Finik аркылуу коопсуз төлөм',
  'Платёж у нас': 'Төлөмүңүз бизде',
  'Открываем доступ к курсу… Можно закрыть окно — доступ откроется автоматически.':
    'Курска жол ачылып жатат… Терезени жапсаңыз болот — жол автоматтык түрдө ачылат.',
  'Это занимает дольше обычного. Платёж получен — если курс не откроется, напишите в поддержку.':
    'Адаттагыдан көпкө созулууда. Төлөм кабыл алынды — курс ачылбаса, колдоо кызматына жазыңыз.',
  'Не удалось определить статус заказа': 'Буйрутманын абалын аныктоо мүмкүн болгон жок',
  'Проверьте ещё раз или напишите в поддержку.': 'Кайра текшериңиз же колдоо кызматына жазыңыз.',
  'Платёж уже получен': 'Төлөм мурунтан эле кабыл алынган',
  'Платёж уже у нас и проверяется. Доступ откроется автоматически. Если нет — напишите в поддержку.':
    'Төлөм бизде жана текшерилүүдө. Жол автоматтык түрдө ачылат. Ачылбаса — колдоо кызматына жазыңыз.',
  Понятно: 'Түшүнүктүү',
  'Покупка ждёт подтверждения': 'Сатып алуу ырастоону күтүүдө',
  'Покупка этого курса в App Store ждёт подтверждения. После одобрения курс откроется автоматически.':
    'Бул курсту App Store аркылуу сатып алуу ырастоону күтүүдө. Бекитилгенден кийин курс автоматтык түрдө ачылат.',
  'Запрос отклонили? Оплатить здесь': 'Четке кагылдыбы? Бул жерден төлөңүз',
  'Отменить ожидание App Store?': 'App Store күтүүсүн жокко чыгарасызбы?',
  'Ожидающая покупка в App Store будет отменена — вы сможете оплатить курс здесь через Finik.':
    'App Store\'догу күтүлгөн сатып алуу жокко чыгарылат — курсту бул жерден Finik аркылуу төлөй аласыз.',
  'Да, оплатить через Finik': 'Ооба, Finik аркылуу төлөө',
  'Отменяем…': 'Жокко чыгарууда…',
  'Ссылка на оплату не прошла проверку. Обновите страницу или напишите в поддержку.':
    'Төлөм шилтемеси текшерүүдөн өткөн жок. Баракты жаңылаңыз же колдоо кызматына жазыңыз.',

  // Order history (payments · MyOrders) + the profile row. «Перейти в каталог» already exists below.
  'Мои заказы': 'Менин заказдарым',
  'Заказов пока нет': 'Азырынча заказдар жок',
  'Здесь появятся ваши покупки курсов.': 'Бул жерде курстарды сатып алууларыңыз көрүнөт.',
  'Ожидает оплаты': 'Төлөмдү күтүүдө',
  Оплачено: 'Төлөндү',
  'Срок истёк': 'Мөөнөтү бүттү',
  Отменён: 'Жокко чыгарылды',
  Проверяется: 'Текшерилүүдө',
  'Ждёт подтверждения': 'Ырастоону күтүүдө',

  // Course difficulty (course-level.ts). Read by BOTH the student pill and the teacher's «Уровень»
  // control, so one entry serves both. Added 2026-07-28 with the one-word labels — the old «Для
  // начинающих» / «Средний уровень» had no Kyrgyz at all and fell back to Russian on a ky-first app.
  Начальный: 'Башталгыч',
  Средний: 'Орто',
  Продвинутый: 'Жогорку',

  // The course's PUBLIC storefront topic (distinct from «Пространство курса», the private classroom).
  'Витрина курса в Telegram': 'Telegram\'деги курстун витринасы',

  // Reviews (CourseReviews)
  Отзывы: 'Пикирлер',
  Оценка: 'Баалоо',
  'Поделитесь впечатлением о курсе…': 'Курс тууралуу пикириңиз менен бөлүшүңүз…',
  'Сохраняем…': 'Сактап жатабыз…',
  'Обновить отзыв': 'Пикирди жаңылоо',
  'Оставить отзыв': 'Пикир калтыруу',
  Удалить: 'Өчүрүү',
  'Пока нет отзывов — станьте первым.': 'Азырынча пикирлер жок — биринчи болуңуз.',
  Ученик: 'Окуучу',
  'Проходил курс': 'Курстан өткөн',
  '{n} из 5': '{n} / 5',

  // Course-completion celebration (CongratsOverlay)
  'Курс пройден': 'Курс аякталды',
  Закрыть: 'Жабуу',
  'Поздравляем — курс пройден!': 'Куттуктайбыз — курс аякталды!',
  'Вы прошли все уроки курса. Так держать — знания решают!':
    'Сиз курстун бардык сабактарын өттүңүз. Ушундай улантыңыз — билим чечет!',
  'Уровень {n}': 'Деңгээл {n}',
  '{n} дн.': '{n} күн',
  // Practice chips: the streak and the all-time record used to render identically in RU too.
  '{n} дн. подряд': '{n} күн удаа',
  'рекорд {n} дн.': 'рекорд {n} күн',
  'К моим курсам': 'Менин курстарыма',

  // Lesson player (LessonPlayerView / LessonSyllabus / LessonContent)
  'Не удалось загрузить урок.': 'Сабакты жүктөө мүмкүн болгон жок.',
  'Раздел {n} · урок {m}': '{n}-бөлүм · {m}-сабак',
  '‹ Назад': '‹ Артка',
  Пройдено: 'Өтүлдү',
  'Отметить пройденным': 'Аяктаган деп белгилөө',
  'Далее ›': 'Кийинки ›',
  '← К курсу': '← Курска',
  'Содержание курса': 'Курстун мазмуну',
  '{n} / {m} уроков': '{n} / {m} сабак',
  'Раздел {n} · {title}': '{n}-бөлүм · {title}',
  'Урок заблокирован': 'Сабак кулпуланган',
  'Запишитесь на курс, чтобы открыть этот урок.': 'Бул сабакты ачуу үчүн курска жазылыңыз.',
  'К странице курса': 'Курстун барагына',
  'Не открывается?': 'Ачылбай жатабы?',
  'Открыть в новой вкладке': 'Жаңы өтмөктө ачуу',

  // Lesson Q&A (LessonDiscussions)
  Вопросы: 'Суроолор',
  'Задать вопрос преподавателю…': 'Мугалимге суроо берүү…',
  Отправить: 'Жөнөтүү',
  'Вопросов пока нет — задайте первый.': 'Азырынча суроолор жок — биринчи болуп бериңиз.',
  'преподаватель ответил': 'мугалим жооп берди',
  '{n} ответ(ов)': '{n} жооп',
  'Загрузка…': 'Жүктөлүүдө…',
  'Пока нет ответов.': 'Азырынча жооптор жок.',
  преподаватель: 'мугалим',
  'Написать @{u} в Telegram': 'Telegram аркылуу @{u} дарегине жазуу',
  написать: 'жазуу',
  'Ответить…': 'Жооп берүү…',
  Ответить: 'Жооп берүү',

  // My learning (MyLearning / LearningCard)
  'Вы ещё не записаны на курсы': 'Сиз азырынча курстарга жазыла элексиз',
  'Найдите курс в каталоге и начните учиться.': 'Каталогдон курс таап, окууну баштаңыз.',
  'Перейти в каталог': 'Каталогго өтүү',
  '{n}/{m} уроков': '{n}/{m} сабак',
  Пространство: 'Мейкиндик',
  'Продолжить →': 'Улантуу →',

  // Quiz player (quiz/*)
  'В этом тесте пока нет вопросов': 'Бул тестте азырынча суроолор жок',
  'Преподаватель ещё не добавил их, поэтому тест нельзя пройти. Спросите его ниже — в «Вопросах».':
    'Мугалим аларды кошо элек, ошондуктан тестти тапшыруу мүмкүн эмес. Төмөндөгү «Суроолор» бөлүмүнөн сураңыз.',
  'Вопрос {n} из {m}': 'Суроо {n} / {m}',
  Назад: 'Артка',
  Далее: 'Кийинки',
  'Проверяем…': 'Текшерүүдө…',
  'Тест завершён!': 'Тест аяктады!',
  Верно: 'Туура',
  Неверно: 'Туура эмес',
  'Введите ваш ответ…': 'Жообуңузду жазыңыз…',
  'Правильно!': 'Туура!',
  Неправильно: 'Туура эмес',
  'Пересмотреть:': 'Кайра көрүү:',

  // Practice (modules/practice)
  Практика: 'Машыгуу',
  'Повторяйте вопросы из пройденных уроков — интервальные повторения закрепляют знания.':
    'Өтүлгөн сабактардагы суроолорду кайталаңыз — интервалдык кайталоо билимди бекемдейт.',
  'Цель на сегодня': 'Бүгүнкү максат',
  'Повторить {n} карточек': '{n} карточканы кайталоо',
  'Начать практику': 'Машыгууну баштоо',
  'Мои ошибки': 'Менин каталарым',
  'Ошибок для повторения нет — отличная работа!': 'Кайталай турган каталар жок — мыкты иш!',
  'Пока нечего повторять — пройдите уроки с тестами.':
    'Азырынча кайталай турган эч нерсе жок — тесттүү сабактарды өтүңүз.',
  'Не удалось получить карточки. Попробуйте позже.':
    'Карточкаларды алуу мүмкүн болгон жок. Кийинчерээк аракет кылыңыз.',
  'Практика завершена!': 'Машыгуу аяктады!',
  'Не удалось сохранить цель.': 'Максатты сактоо мүмкүн болгон жок.',
  'Изменить цель (5–100)': 'Максатты өзгөртүү (5–100)',
  'Следующее повторение: {date}': 'Кийинки кайталоо: {date}',
  '+{n} XP за курс!': 'Курс үчүн +{n} XP!',
  'Список синхронизируется с сервером и доступен с любого устройства.':
    'Тизме сервер менен синхрондоштурулуп, каалаган түзмөктөн жеткиликтүү.',
  'К практике': 'Машыгууга',
  '← Выйти': '← Чыгуу',
  'Карточка {n} из {m}': 'Карточка {n} / {m}',

  // Live-now banner (modules/live)
  'Сейчас идёт эфир': 'Азыр эфир жүрүп жатат',
  Присоединиться: 'Кошулуу',
  // Course landing «Эфиры» section (CourseSessionsSection) + the My-Courses live pip
  Прошедшие: 'Өткөндөр',
  Запись: 'Жазуу',
  'Хотим эфир': 'Эфир каалайбыз',
  'Вы попросили эфир': 'Сиз эфир сурадыңыз',
  'Эфир идёт': 'Эфир жүрүп жатат',

  // Viewmodel error fallbacks
  'Не удалось записаться. Попробуйте позже.': 'Жазылуу мүмкүн болгон жок. Кийинчерээк аракет кылыңыз.',
  'Не удалось сохранить отзыв.': 'Пикирди сактоо мүмкүн болгон жок.',
  'Не удалось удалить отзыв.': 'Пикирди өчүрүү мүмкүн болгон жок.',
  'Не удалось отправить вопрос.': 'Суроону жөнөтүү мүмкүн болгон жок.',
  'Не удалось отправить ответ.': 'Жоопту жөнөтүү мүмкүн болгон жок.',
  'Не удалось отправить ответ. Попробуйте ещё раз.':
    'Жоопту жөнөтүү мүмкүн болгон жок. Кайра аракет кылыңыз.',

  // Programs public surfaces (PR #184: banner carousel · program page · provider page · related rail).
  // «Программа», «Академия», «Баннер {n}» are identical in ky — deliberately absent.
  '← Назад': '← Артка',
  'Похожие курсы': 'Окшош курстар',
  'Программа не найдена или скрыта.': 'Программа табылган жок же жашырылган.',
  'Страница школы недоступна.': 'Мектептин баракчасы жеткиликтүү эмес.',
};
